import React, { useCallback, useEffect, useRef } from "react"

import { formatMobilePhone } from "utils"
import { Spinner } from "components"
import { getAddresses } from "services"
import classes from "./PocaacsDropdown.module.scss"

const PocaacsDropdown = (props) => {
  const {
    inputRef,
    menuRef,
    users,
    setUsers,
    showMenu,
    setShowMenu,
    setCustomerInfo,
    setCustomerAddress
  } = props

  const unmount = useRef(false)

  const handleSelectUser = async (user) => {
    setCustomerInfo({
      accountId: user._id,
      fullName: user.fullName,
      mobilePhone: formatMobilePhone(user.mobilePhone)
    })

    setShowMenu(false)

    setUsers(null)

    const response =
      await getAddresses({
        accountId: user._id
      })

    if (unmount.current) return

    const initialCustomerAddress = response[0]

    if (!initialCustomerAddress) return

    setCustomerAddress(prev => ({
      ...initialCustomerAddress,
      areaName: prev.areaName,
      recipientPhoneNumber:
        formatMobilePhone(initialCustomerAddress.recipientPhoneNumber)
    }))
  }

  const handleClickOutSide =
    useCallback((event) => {
      if (!!inputRef.current?.contains(event.target)) return

      if (!!menuRef.current?.contains(event.target)) return

      setShowMenu(false)
    }, [])

  useEffect(() => {
    unmount.current = false

    window.addEventListener("click", handleClickOutSide)

    return () => {
      unmount.current = true

      window.removeEventListener("click", handleClickOutSide)
    }
  }, [])

  if (!showMenu) return null

  return (
    <div
      ref={menuRef}
      className={classes["menu"]}
    >
      {users !== null
        ?
        users.map(user =>
          <div
            key={user._id}
            onClick={() => handleSelectUser(user)}
            className={classes["menu-item"]}
          >
            {user.fullName} ({formatMobilePhone(user.mobilePhone)})
          </div>
        )
        :
        <div className={classes["loading"]}>
          <Spinner color="var(--color-primary)" size={20} />
        </div>
      }
    </div>
  )
}

export default PocaacsDropdown